const MS_PER_WEEK = 7 * 24 * 60 * 60 * 1000;

export function getStrategyTimelinePresentation(strategy, now = new Date()) {
  const totalWeeks = Math.max(1, Number(strategy?.data?.timeline_weeks || 12));
  const phases = Array.isArray(strategy?.data?.phases) ? strategy.data.phases : [];
  const startValue = strategy?.started_at || strategy?.activated_at || strategy?.created_at;
  const start = startValue ? new Date(startValue) : null;
  const validStart = start && !Number.isNaN(start.getTime());
  const weeksElapsed = validStart
    ? Math.floor(Math.max(0, new Date(now).getTime() - start.getTime()) / MS_PER_WEEK)
    : 0;
  const isComplete = weeksElapsed >= totalWeeks;
  const currentWeek = Math.min(weeksElapsed + 1, totalWeeks);
  let currentPhaseIndex = phases.length > 0 ? 0 : -1;

  if (isComplete) {
    currentPhaseIndex = phases.length;
  } else {
    for (let index = 0; index < phases.length; index += 1) {
      const match = String(phases[index]?.weeks || '').match(/(\d+)\s*-\s*(\d+)/);
      if (!match) continue;
      if (weeksElapsed >= Number(match[1]) - 1 && weeksElapsed < Number(match[2])) {
        currentPhaseIndex = index;
        break;
      }
    }
  }

  return {
    totalWeeks,
    weeksElapsed,
    currentWeek,
    isComplete,
    currentPhaseIndex,
    weekLabel: isComplete ? `Completed ${totalWeeks} of ${totalWeeks}` : `${currentWeek} of ${totalWeeks}`
  };
}
